"use client";

import { devLabel } from "@/lib/dev-labels";
import styles from "./NarrationPanel.module.css";
import { TONES } from "./narration-data";

/**
 * ToneGrid — 12 tone chips.
 *
 * Mockup source: docs/mockups/narration.html panel 24-D.
 * 6-column grid. Single-select.
 */

export interface ToneGridProps {
	selected: string | null;
	onSelect: (key: string) => void;
}

export function ToneGrid({ selected, onSelect }: ToneGridProps) {
	return (
		<div data-testid="tone-grid">
			<div className={styles.sectionH} {...devLabel("24-D")}>
				<span>톤 ({TONES.length}종)</span>
				<span className={styles.sectionCount}>{selected ? "1" : "0"} 선택</span>
			</div>
			<div className={styles.toneGrid} role="radiogroup" aria-label="톤">
				{TONES.map((tone, i) => {
					const on = selected === tone.key;
					return (
						<button
							key={tone.key}
							type="button"
							role="radio"
							aria-checked={on}
							aria-label={tone.name}
							className={`${styles.toneCard} ${on ? styles.toneCardOn : ""}`}
							data-testid={`tone-${tone.key}`}
							onClick={() => onSelect(tone.key)}
							{...devLabel(`24-D${i + 1}`)}
						>
							<div className={styles.toneIco} aria-hidden="true">
								{tone.glyph}
							</div>
							<div className={styles.toneName}>{tone.name}</div>
							<div className={styles.toneEn}>{tone.en}</div>
						</button>
					);
				})}
			</div>
		</div>
	);
}
